export type ConfigSection =
  | 'mi-cuenta'
  | 'mis-celulas'
  | 'notificaciones'
  | 'iglesia-funcionamiento'
  | 'iglesia-reuniones'
  | 'iglesia-eventos'
  | 'estado-servicio';

export const CONFIG_SECTION_TITLES: Record<ConfigSection, string> = {
  'mi-cuenta': 'Mi cuenta',
  'mis-celulas': 'Mis células',
  notificaciones: 'Notificaciones',
  'iglesia-funcionamiento': 'Funcionamiento',
  'iglesia-reuniones': 'Reuniones y discipulado',
  'iglesia-eventos': 'Eventos',
  'estado-servicio': 'Estado del servicio',
};

export const CONFIG_SECTION_DEFAULT: ConfigSection = 'mi-cuenta';
